export function isEventAddOnAvailable(
  addOn: { minGuests?: number | null },
  guests: number
) {
  return addOn.minGuests == null || guests >= addOn.minGuests;
}
